export const translations = {
  " import cen": "Nhập giá ",
  "< Wróć": "< Trở lại",
  "Akcje": "Đấu giá ",
  "Aktualizuj stany": "Cập nhật trạng thái",
  "Aktywność": "Hoạt động",
  "Aktywny": "Hoạt động",
  "Aktywny do": "Hoạt động tới",
  "Aktywowany": "Kích hoạt",
  "Anuluj": "Hủy bỏ",
  "Autor": "Tác giả",
  "Baner...": "Băng rôn",
  "Banery": "Băng rôn",
  "Biodra": "Ngực",
  "Biust": "Mông",
  "Brak historii zamówień": "Không có lịch sử đơn đặt hàng",
  "Brak zdjęcia": "Không có hình",
  "Cancel": "Hủy bỏ",
  "Cena": "Giá",
  "Cena do": "Giá đến",
  "Cena docelowa": "Giá mục tiêu",
  "Cena od": "Giá từ",
  "Cena przed obniżką": "Giá trước khi giảm giá",
  "Cena przekreślona": "Giá bỏ ",
  "Cena przekreślona do": "Giá bỏ đến",
  "Cena przekreślona od": "Giá bỏ từ",
  "Cena sprzedaży": "Giá bán",
  "Cena sprzedaży do": "Giá bán đến",
  "Cena sprzedaży od": "Giá bán từ",
  "Cena wyświetlana": "Giá hiển thị",
  "Cena zakupu": "Giá mua",
  "Cena zakupu do": "Giá mua đến",
  "Cena zakupu netto": "Giá mua ròng",
  "Cena zakupu od": "Giá mua từ",
  "Ceny produktu": "Giá sản phẩm",
  "Czas utworzenia": "Thời gian tạo",
  "Czy na pewno chcesz usunąć stronę?": "Bạn có chắc chắn muốn xóa trang không?",
  "Dane do wysyłki": "Thông tin vận chuyển",
  "Dane kontaktowe": "Chi tiết liên lạc",
  "Data": "Ngày",
  "Data aktywacji": "Ngày kích hoạt",
  "Data utworzenia": "Ngày tạo",
  "Do daty utworzenia": "Đến ngày tạo",
  "Do sztuk": "Nhánh",
  "Dodaj": "Thêm ",
  "Dodaj efekt": "Thêm hiệu ứng",
  "Dodaj główną kategorię": "Thêm danh mục chính",
  "Dodaj kategorię": "Thêm danh mục",
  "Dodaj kupon": "Thêm phiếu giảm giá",
  "Dodaj modelkę": "Thêm mô hình",
  "Dodaj nową modelkę": "Thêm mô hình mới",
  "Dodaj opinię": "Thêm đánh giá",
  "Dodaj produkt": "Thêm sản phẩm",
  "Dodaj stronę": "Thêm trang",
  "Dodaj warunki": "Thêm tình trạng",
  "Dostawa": "Giao hàng",
  "Dostępne": "Có sẵn",
  "Dostępność w przyszłości": "Sẽ cập nhật sau",
  "Dzieci": "Trẻ em",
  "Dzisiejsza": "Hiện tại",
  "EAN": "EAN",
  "ENTER": "Nhập",
  "Edytuj": "Chỉnh sửa",
  "Edytuj modelkę": "Sửa mẫu",
  "Edytuj opinię": "Sửa đánh giá",
  "Edytuj wiele produktów": "Sửa nhiều sản phẩm",
  "Eksportuj ceny produktów": "Giá sản phẩm xuất",
  "Element skopiowany do schowka": "Đã sao chép vào bộ nhớ",
  "Followersów": "Người theo dõi ",
  "Forma wysyłki": "Hình thức giao hàng",
  "Gdzie ma przejść po kliknięciu": "Đi đâu sau khi nhấp vào",
  "Grupa produktów": "Nhóm sản phẩm",
  "Historia": "Lịch sử",
  "Historia (0)": "Lịch sử (0)",
  "Historia (1)": "Lịch sử (1)",
  "Historia sprzedaży": "Lịch sử bán hàng",
  "Historia zamówień": "Lịch sử đặt hàng",
  "ID": "ID",
  "ID opinii": "ID đánh giá",
  "Ilość": "Số lượng",
  "Ilość na stanie": "Số lượng hàng tồn kho",
  "Ilość postów": "Số lượng bài đăng",
  "Imię": "Tên",
  "Importuj ceny": "Nhập giá",
  "Importuj dane z born2be": "Nhập dữ liệu từ born2be",
  "Indywidualny numer konta do wpłat": "Số tài khoản cá nhân cho thanh toán ",
  "Informacje o opinii": "Thông tin về ý kiến",
  "Instagram": "Instagram",
  "Język": "Ngôn ngữ",
  "Język panelu": "Ngôn ngữ của tiêu đề",
  "Język treści" : "Ngôn ngữ của nội dung",
  "Język dynamicznych treści," : "Ngôn ngữ của nội dung động",
  "Język tekstów statycznych" : "Ngôn ngữ của nội dung tĩnh",
  "Kategoria": "Hạng mục",
  "Kategorie": "Hạng mục",
  "Kliknij, aby anulować edycję parametrów i modelek": "Nhấp để hủy chỉnh sửa dữ liệu",
  "Kliknij, aby edytować kategorie": "Nhấp để chỉnh sửa danh mục",
  "Kliknij, aby edytować parametry i modelki": "Nhấp để chỉnh sửa dữ liệu",
  "Kliknij, aby edytować zdjęcia": "Nhấp để chỉnh sửa ảnh",
  "Kobiety": "Nữ",
  "Kod": "Mã",
  "Kod Package EAN": "Gói mã EAN",
  "Kod Polski": "Mã Ba Lan",
  "Kod celny": "Mã chuẩn",
  "Kod chiński": "Mã Trung Quốc",
  "Kod polski": "Mã Ba Lan",
  "Kod produktu": "Mã sản phẩm",
  "Kody chińskie": "Mã Trung Quốc",
  "Kolor": "Màu",
  "Komfortu": "Tiện nghi",
  "Koszty wysyłki": "Chi phí vận chuyển",
  "Kup mniejsze": "Mua ít hơn",
  "Kup większe": "Mua nhiều",
  "Kupony": "Phiếu giảm giá",
  "Kupony - dodaj": "Phiếu giảm giá - thêm",
  "Lato": "Mùa hè",
  "Liczba mieszkańców": "Số lượng",
  "Liczba postów 12": "Số bài đăng 12",
  "Liczba postów 24": "Số bài đăng 24",
  "Liczba postów 36": "Số bài đăng 36",
  "Liczba postów 48": "Số bài đăng 48",
  "Liczba postów 60": "Số bài đăng 60",
  "Liczba znaków": "Số ký tự",
  "Lista kategorii": "Danh mục",
  "Lista kuponów": "Danh sách các phiếu giảm giá",
  "Lista postów": "Danh sách bài đăng",
  "Lista produktów": "Danh sách sản phẩm",
  "Lista stron": "Danh sách các trang",
  "Losuj": "Ngẫu nhiên",
  "Marketing": "Thị trường",
  "Max Date": "Ngày tối đa",
  "Menu": "Danh mục",
  "Meta keywords": "Từ khóa Meta",
  "Meta description": "Mô tả Meta",
  "Miasto": "Thành phố",
  "Min Date": "Ngày tối thiểu",
  "Modelki": "Mẫu",
  "Models": "Mẫu",
  "Męski": "Nam",
  "Męzczyzni": "Nam",
  "Mężczyzn": "Nam",
  'Można łączyć' : 'Có thể kết hợp',
  "Następny": "Kế tiếp",
  "Nazwa": "Tên",
  "Nazwa pojedyncza": "Tên riêng",
  "Nazwa produktu": "Tên sản phẩm",
  "Nazwa użytkownika": "Tên đăng nhập",
  "Nazwa wewnętrzna": "Tên khác",
  "Nie można łączyć": "Không thể kết hợp",
  "Nieaktywny": "Không hoạt động",
  "Niedostępne": "Không có sẵn",
  "Nieunikalny": "Không duy nhất",
  "Niezaakceptowane": "Không được chấp nhận",
  "Niezaakceptowany": "Không chấp nhận",
  "Nijaki": "Trung lập",
  "Nijaki mnogi": "Số nhiều",
  "Notatki": "Ghi chú",
  "Numer strony": "Số trang",
  "O autorze": "Về tác giả",
  "OK": "Tốt",
  "Obniżenie ceny o %": "Giảm giá theo%",
  "Obniżka obecna (%)": "Giảm hiện tại (%)",
  "Ocena": "Đánh giá",
  "Ocena komfortu": "Xếp hạng tiện nghi",
  "Ocena stylu": "Đánh giá kiểu dáng",
  "Od daty utworzenia": "Từ ngày tạo",
  'Od najmniejszej' : "Từ số nhỏ nhất",
  "Od największej": "Từ số lớn nhất",
  "Od sztuk": "Từ nhánh",
  "Odśwież cache": "Làm mới bộ nhớ",
  "Odśwież linki": "Làm mới liên kết",
  "Ogólna": "Tổng quan",
  "Opinie": "Đánh giá",
  "Opis kategorii": "Mô tả hạng mục",
  "Opis meta": "Mô tả meta",
  "Opis produktu": "Mô tả sản phẩm",
  "Otwórz": "Mở ",
  "Otwórz wyszukiwarkę": "Mở công cụ tìm kiếm",
  "Package EAN (zablokowane)": "Gói EAN (bị chặn)",
  "Parametry": "Thông số",
  "Pełna nazwa": "Họ tên",
  "Pobierz raport cen produktów": "Tải báo cáo giá sản phẩm",
  "Podgląd": "Xem trước",
  "Podstawowe info": "Thông tin cơ bản",
  "Poprzedni": "Trước",
  "Pora roku": "Mùa",
  "Połącz w grupę": "Kết hợp thành một nhóm",
  "Producent": "Nhà sản xuất",
  "Produkt": "Sản phẩm",
  "Produkty": "Sản phẩm",
  "(produktów, kategorii itp)":"(sản phẩm, danh mục, v.v.)",
  "Przecena do ( % )": "Bán đến (%)",
  "Przecena od ( % )": "Bán từ (%)",
  "Przejdź do sklepu": "Đi đến cửa hàng",
  "Przenieś niżej": "Chuyển xuống dưới",
  "Przenieś wyżej": "Chuyển lên trên",
  "Przypisz": "Chuyển nhượng",
  "Płatność": "Thanh toán",
  "Razem": "Tổng",
  "Raporty": "Báo cáo",
  "Raporty cen": "Báo giá",
  "Rodzaj nazwy": "Tên ",
  "Rodzaj przekierowania": "Loại chuyển hướng",
  'Rozmiar' : "Kích thước",
  "Rozmiar obuwia": "Kích thước của giày",
  "Rozmiarówka": "Cỡ bảng",
  "Sortowanie": "Sắp xếp",
  'Stan aktywacji':'Trạng thái kích hoạt',
  "Status": "Trạng thái",
  "Strony statyczne": "Trang tĩnh",
  "Strony statyczne - edycja.":"Trang tĩnh - chỉnh sửa.",
  "Strony statyczne - nowa.":"Trang tĩnh - mới.",
  "Stylu": "Phong cách",
  "Submit": "Gửi",
  "Suma": "Tổng số",
  "Szablon": "Mẫu",
  "Szczegóły": "Chi tiết",
  "Szczegóły zamówienia": "Chi tiết đơn đặt hàng",
  "Szukaj kategorii...": "Danh mục tìm kiếm ...",
  "Słowa kluczowe": "Từ khoá",
  "Słowo kluczowe": "Từ khóa",
  "% przeceny": "% Việc bán hàng",
  "Minimalny % przeceny": "% Chiết khấu tối thiểu",
  "Maksymalny % przeceny": "% Chiết khấu tối đa",
  "Dodaj warunki wielorabatowe": "Thêm nhiều điều kiện chiết khấu",
  "Tag": "Thẻ",
  "Talia": "Hông",
  "Total": "Tổng",
  "Treść": "Nội dung",
  "Treść opinii": "Nội dung ý kiến",
  "Trwa ładowanie": "Đang tải",
  "Typ": "Phân loại",
  "Typ baneru": "Loại biểu ngữ",
  "Typowa": "Kiểu mẫu",
  "Tytuł": "Tiêu đề",
  "Tytuł linku": "Tiêu đề liên kết",
  "Tytuł produktu": "Tên sản phẩm",
  'Typ strony':'Loại trang',
  'Unikalny':'Duy nhất',
  "Upload": "Tải",
  "Ustaw dzisiejszą": "Đặt ngày hôm nay",
  "Usuń": "Xóa",
  "Usuń modelkę": "Xóa mẫu",
  "Uwaga": "Chú ý",
  "Vices status": "Trạng thái Vices",
  "Voucher": "Voucher",
  "Wartość": "Giá trị",
  "Wartość efektu": "Giá trị hiệu ứng",
  "Wartość produktów": "Giá trị sản phẩm",
  "Ważny do": "Hợp lệ đến",
  "Ważny od": "Có hiệu lực từ",
  "Wgrywanie zdjęć": "Tải lên ảnh",
  "Wiosna/Jesień": "Xuân-Thu",
  "Wpisz alt zdjęcia": "Nhập ảnh thay thế",
  "Wpisz kod celny": "Nhập mã chuẩn",
  "Wpisz link": "Nhập liên kết",
  "Wpisz nazwę": "Nhập tên",
  "Wpisz nazwę baneru": "Nhập tên của biểu ngữ",
  "Wpisz nazwę pojedynczą": "Nhập một tên duy nhất",
  "Wpisz nowy EAN": "Nhập EAN mới",
  "Wpisz opis kategorii": "Nhập mô tả danh mục",
  "Wpisz opis meta": "Nhập mô tả của meta",
  "Wpisz słowa kluczowe": "Nhập từ khóa",
  "Wprowadź ean": "Nhập ean",
  "Wprowadź kod": "Nhập mã",
  "Wprowadź kody chińskie": "Nhập mã Trung Quốc",
  "Wprowadź nazwę": "Nhập tên",
  "Wprowadź nazwę produktu": "Nhập tên sản phẩm",
  "Wprowadź nazwę tagu": "Nhập tên thẻ",
  "Wprowadź nazwę użytkownika": "Nhập tên người dùng",
  "Wprowadź tag": "Nhập thẻ",
  "Wróć": "Trả lại",
  "Wszystkie": "Tất cả",
  'Wybierz importowane pola':'Chọn các trường nhập',
  "Wybierz jedno z proponowanych słów kluczowych lub wpisz własne i naciśnij": "Chọn một trong những từ khóa được đề xuất hoặc nhập từ khóa của bạn và nhấn",
  "Wybierz kategorie": "Chọn danh mục",
  "Wybierz poniżej...": "Chọn bên dưới ...",
  "Wybierz...": "Chọn ...",
  "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.": "Chọn một bức ảnh nhất định và gửi cho máy chủ của chúng tôi! Hãy đảm bảo rằng tệp bạn đang tải lên là chính xác.",
  "Wyczyść filtry": "Xóa bộ lọc",
  "Wyloguj się": "Đăng xuất",
  "Wymiary": "Kích thước",
  "Wyszukaj": "Tìm kiếm",
  "Wyszukaj po id opinii": "Tìm kiếm theo id phản hồi",
  "Wyszukaj po imieniu": "Tìm kiếm theo tên",
  "Wyszukaj po kodzie produktu": "Tìm kiếm theo mã sản phẩm",
  "Wyszukaj po mieście": "Tìm kiếm xung quanh thành phố",
  "Wzrost": "Chiều cao",
  "Zamknij": "Đóng ",
  "Zamknij wyszukiwarkę": "Đóng công cụ tìm kiếm",
  "Zamówienia": "Đơn đặt hàng",
  "Zamówienie numer": "Số đơn đặt hàng",
  "Zamówienie odrzucone": "Đơn hàng bị từ chối",
  "Zamówiona ilość": "Số lượng đặt hàng",
  "Zapisz": "Lưu",
  "Zapisz zmiany": "Lưu thay đổi",
  "Zatwierdź": "Gửi",
  "Zaznaczonych produktów": "Sản phẩm đã chọn",
  "Zdjęcia": "Hình ảnh",
  "Zdjęcie mobile": "Ảnh từ điện thoại",
  "Zdjęcie modelki": "Ảnh mẫu",
  "Zdjęcie na desktop": "Ảnh trên máy tính",
  "Zima": "Mùa đông",
  "Zmień": "Thay đổi",
  "Zmień EAN": "Thay đổi EAN",
  "Zmień status": "Thay đổi trạng thái",
  "Zmień wszędzie": "Thay đổi tất cả",
  "Zobacz": "Theo dõi",
  "shipSpeed": "Tốc độ vận chuyển",
  "ubrań": "Quần áo",
  "Żeński": "Nữ",
  "Анастасія": "Анастасія",
  "Анна": "Анна",
  "Богуслава": "Богуслава",
  "Ева": "Ева",
  "Любовь": "Любовь",
  "Мирослава": "Мирослава",
  "Наталья": "Наталья",
  "Раиса": "Раиса",
  "Регіна": "Регіна",
  "Соломия": "Соломия",
  "Тетяна": "Тетяна",
  "Ярина": "Ярина"
};



// WEBPACK FOOTER //
// ./locales/vi_VN/translations.js